require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-should-i-lease-or-purchase-a-car.json") })
        }
      }, "path---calculators-should-i-lease-or-purchase-a-car");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-should-i-lease-or-purchase-a-car!./.cache/json/calculators-should-i-lease-or-purchase-a-car.json
// module id = 2020
// module chunks = 231608221292675